/**
 * @file NetworkInformation
 * @author dafo<huanghouin@baijiahulian.com>
 * @module util/performance
 */
const {
    type: nt = 'unknown',
    effectiveType: net = '',
    rtt: nrtt = 0,
    downlinkMax: ndlm = 0,
    downlink: ndl = 0
} = typeof navigator !== 'undefined' && navigator.connection || {};


/**
 * @name connection
 * @see https://developer.mozilla.org/en-US/docs/Web/API/NetworkInformation
 */
export default {
    // network type
    nt,
    // effectiveType
    net,
    // round-trip time
    nrtt,
    // downlinkMax
    ndlm,
    // downlink
    ndl
};
